import styled, { css } from 'styled-components';
import { gray25, gray90, spacer4, spacer12, spacer20, screenXsMax, screenSmMin } from '@spotify-internal/encore-foundation';
import { ie11 } from "../../styles";

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.dialogConfirmation === 'dark';
};

export default styled.div.withConfig({
  displayName: "Body",
  componentId: "sc-1b7e5k7-0"
})(["border-bottom:1px solid ", ";overflow:auto;@media (max-width:", "){padding:0 ", " ", ";}@media (min-width:", "){padding:0 ", " ", ";}", ";"], function (props) {
  return isDarkTheme(props) ? gray25 : gray90;
}, screenXsMax, spacer20, spacer4, screenSmMin, spacer20, spacer12, ie11(css(["max-height:300px;"])));